export default "<!-- <app-sidebar></app-sidebar>\n<app-header></app-header>\n<router-outlet></router-outlet> -->\n"